import Vue from 'vue'
import * as types from '../mutation-types'

const state = {
  contactArray: {},
  curContact: {},
  explains: {},
  isOpenAddNew: {},
  contactType: '',
  contactKey: 0,
  delContactArray: {}
}

// getters
const getters = {
  contactArray: state => state.contactArray[state.contactType] || [],
  curContact: state => state.curContact[state.contactType] || [],
  isOpenAddNew: state => state.isOpenAddNew[state.contactType] || false,
  explains: state => state.explains[state.contactType] || [],
  contactType: state => state.contactType,
  delContactArray: state => state.delContactArray[state.contactType] || []
}

// actions
const actions = {
  setContactArray ({ commit }, payload) {
    commit(types.SET_CONTACT_ARRAY, payload)
  },
  setExplains ({ commit }, payload) {
    commit(types.SET_EXPLAINS, payload)
  },
  openAddNew ({ commit }, payload) {
    commit(types.OPEN_ADDNEW, payload)
  },
  setContactType ({ commit }, payload) {
    commit(types.SET_CONTACT_TYPE, payload)
  },
  initContact ({ commit }, payload) {
    commit(types.INIT_CONTACT, payload)
  }
}

// mutations
const mutations = {
  [types.SET_CONTACT_ARRAY] (state, obj) {
    let array = state.contactArray[state.contactType] || []
    let delArray = state.delContactArray[state.contactType] || []
    if (obj.contact) {
      let isPush = true
      let i
      array.forEach((item, index) => {
        if ((item.id !== '0' && item.id === obj.contact.id) || item.key === obj.contact.key) {
          i = index
          isPush = false
          return
        }
      })
      if (isPush) {
        state.contactKey = state.contactKey + 1
        obj.contact.key = state.contactKey
        array.push(obj.contact)
      } else {
        array.splice(i, 1)
        array.splice(i, 0, JSON.parse(JSON.stringify(obj.contact)))
      }
    } else {
      if (array[obj.index].id && array[obj.index].id !== '0') {
        delArray.push(array[obj.index])
      }
      array.splice(obj.index, 1)
    }
    Vue.set(state.delContactArray, state.contactType, delArray)
    Vue.set(state.contactArray, state.contactType, array)
  },
  [types.SET_EXPLAINS] (state, status) {
    Vue.set(state.explains, state.contactType, status)
  },
  [types.OPEN_ADDNEW] (state, obj) {
    if (obj.isOpenAddNew) {
      if (obj.index === 0 || obj.index) {
        Vue.set(state.curContact, state.contactType, state.contactArray[state.contactType][obj.index])
      } else {
        state.contactKey = state.contactKey + 1
        let obj = {
          id: '0',
          operate: 'i',
          key: state.contactKey,
          isEdit: false,
          form: {},
          explains: {}
        }
        Vue.set(state.curContact, state.contactType, obj)
      }
    }
    Vue.set(state.isOpenAddNew, state.contactType, obj.isOpenAddNew)
  },
  [types.SET_CONTACT_TYPE] (state, status) {
    state.contactType = status
  },
  [types.INIT_CONTACT] (state, status) {
    Vue.set(state.contactArray, state.contactType, [])
    Vue.set(state.explains, state.contactType, [])
    Vue.set(state.curContact, state.contactType, {})
    Vue.set(state.delContactArray, state.contactType, [])
    state.contactKey = 0
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/customer.js